import { ACTION_TYPES, RESOURCE_TYPES } from "@utils/auditFormatters";

export default function AuditFiltersBar({
  startDate,
  endDate,
  actionType,
  resourceType,
  onStartDateChange,
  onEndDateChange,
  onActionTypeChange,
  onResourceTypeChange,
  onApply,
  loading,
}) {
  return (
    <div className="rounded-2xl border bg-white p-5">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <span className="p-2 rounded-xl bg-slate-50 border">
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={1.8}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
              />
            </svg>
          </span>
          <span className="font-semibold text-slate-900">Filters</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          {/* Start Date */}
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Start Date
            </label>
            <input
              type="date"
              className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200 disabled:opacity-50 disabled:cursor-not-allowed"
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              disabled={loading}
            />
          </div>

          {/* End Date */}
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              End Date
            </label>
            <input
              type="date"
              className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200 disabled:opacity-50 disabled:cursor-not-allowed"
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              disabled={loading}
            />
          </div>

          {/* Action Type */}
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Action Type
            </label>
            <select
              className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200 disabled:opacity-50 disabled:cursor-not-allowed"
              value={actionType}
              onChange={(e) => onActionTypeChange(e.target.value)}
              disabled={loading}
            >
              {ACTION_TYPES.map((action) => (
                <option key={action.value} value={action.value}>
                  {action.label}
                </option>
              ))}
            </select>
          </div>

          {/* Resource Type */}
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Resource Type
            </label>
            <select
              className="w-full border rounded-xl px-3 py-2.5 bg-white focus:outline-none focus:ring-2 focus:ring-sky-200 disabled:opacity-50 disabled:cursor-not-allowed"
              value={resourceType}
              onChange={(e) => onResourceTypeChange(e.target.value)}
              disabled={loading}
            >
              {RESOURCE_TYPES.map((resource) => (
                <option key={resource.value} value={resource.value}>
                  {resource.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Apply Filters Button */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onApply}
            disabled={loading}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border bg-sky-600 hover:bg-sky-700 text-white font-medium text-sm shadow-sm disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.3-4.3m1.8-5.2a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            {loading ? "Loading…" : "Apply Filters"}
          </button>
        </div>
      </div>
    </div>
  );
}
